'use client';
 
import { useEffect } from 'react';
 
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Check if the error is a hydration error and suppress it
    if (error.message.includes('Hydration')) {
      // Log it for debugging but suppress the error UI
      console.log('Suppressed hydration error:', error.message);
      reset(); // Try to reset the error
    } else {
      // Log any other errors to the console
      console.error('Application error:', error);
    }
  }, [error, reset]);
 
  // Return null when it's a hydration error to prevent showing an error UI
  if (error.message.includes('Hydration')) {
    return null;
  }
 
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4">
      <h2 className="text-2xl font-bold mb-4">Something went wrong!</h2>
      <button
        className="px-4 py-2 bg-rise-primary text-white rounded-md hover:bg-rise-dark transition-colors"
        onClick={reset}
      >
        Try again
      </button>
    </div>
  );
}